export const getDonorCount = amount => {
  const {
    locale
  } = Intl.DateTimeFormat().resolvedOptions();
  const donorCount = new Intl.NumberFormat(locale, {
    style: 'decimal',
    notation: 'compact'
  }).format(amount);
  return donorCount;
};
export const formatPercentToGoal = amount => {
  const {
    locale
  } = Intl.DateTimeFormat().resolvedOptions();
  const percentToGoal = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount).replace(/.00$/, '');
  return `${percentToGoal}%`;
};